import React from 'react';

const trustBadges = [
  {
    id: 1,
    title: "Envío Gratis",
    description: "En compras superiores a $3.000 a todo el país con seguimiento incluido.",
    icon: "fa-solid fa-truck-fast"
  },
  {
    id: 2,
    title: "Cambios Fáciles",
    description: "30 días para cambios y devoluciones sin complicaciones.",
    icon: "fa-solid fa-arrow-rotate-left"
  },
  {
    id: 3,
    title: "Pago Seguro",
    description: "Hasta 6 cuotas sin interés con Mercado Pago.",
    icon: "fa-solid fa-shield-halved"
  },
  {
    id: 4,
    title: "Calidad Premium",
    description: "Materiales seleccionados y confección de primera calidad.",
    icon: "fa-solid fa-gem"
  }
];

const ServicesSection = () => {
  return (
    <section style={{
      padding: 'clamp(40px, 8vw, 80px) clamp(16px, 4vw, 40px)',
      background: 'var(--bg-secondary)'
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '24px'
        }}>
          {trustBadges.map(badge => (
            <div key={badge.id} style={{
              textAlign: 'center',
              padding: '32px 20px'
            }}>
              <div style={{
                width: '48px',
                height: '48px',
                margin: '0 auto 20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid var(--border-medium)',
                background: 'var(--bg-white)'
              }}>
                <i className={badge.icon} style={{
                  fontSize: '1rem',
                  color: 'var(--text-primary)'
                }}></i>
              </div>
              <h4 style={{
                fontFamily: 'var(--font-body)',
                fontSize: '0.78rem',
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: '0.12em',
                color: 'var(--text-primary)',
                marginBottom: '10px'
              }}>
                {badge.title}
              </h4>
              <p style={{
                color: 'var(--text-muted)',
                fontSize: '0.82rem',
                lineHeight: 1.6,
                margin: 0
              }}>
                {badge.description}
              </p>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 992px) {
          section > div > div {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }
        @media (max-width: 576px) {
          section > div > div {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
};

export default ServicesSection;
